<div class="container">
    <div *ngFor="let sc of souscategories" class=" mx-auto text-center div-btn-cat">          
        <button class="btn-cat" (click)="choixJeu(sc)">{{ sc.nom }}</button>  
    </div>
</div>
